<multi-extended-filterable-select2
	[id]="id"
	[disabled]="disabled"
	[fieldClass]="_fieldClass"
	[maxNumberOfSelections]="maxNumberOfSelections"
	[keyGetter]="getOuvrageId"
	[labelGetter]="getOuvrageLabel"
	[categoryList]="sousParcs"
	[categoryLabelGetter]="getSousParcLabel"
	[wildcardCategoryLabel]="'... dans le parc au complet'"
	[categoryChecker]="checkCategory"
	[reinitCommands]="reinitSubject"
	(selectedItemsChange)="onSelectedOuvragesChange($event)"
	>

	<ng-template let-ouvrage>
		<ng-template [ngIf]="memosByOuvrageId.get(ouvrage.id)">
			<div [ngClass]="_notesClass" style="margin-top: 8px">
				<div class="form-group" style="margin-bottom: 0">
					<label for="memoParcs" class="col-sm-3 control-label memo-ouvrage">M&eacute;mos : </label>
					<div class="col-sm-9 memo-associes">
						<ul style="margin-bottom: 0">
							<li *ngFor="let memo of getOuvrageMemos(ouvrage)" class="popover__wrapper">
								<span [ngClass]="memo.niveauId == 1 ? 'text-primary' : 'text-danger'">{{ getMemoCategorie(memo) }}{{ memo.intitule }}
									<span *ngIf="memo.dateDebut && !memo.dateFin">
			            				(le {{ memo.dateDebut | displayLocalDate }})
			          				</span>
			          				<span *ngIf="memo.dateDebut && memo.dateFin">
			            				(du {{ memo.dateDebut | displayLocalDate }} au {{ memo.dateFin | displayLocalDate }})
			          				</span>
								</span>
								<div class="popover__content">
									<div class="panel panel-default">
										<div class="panel-heading" role="document">
											<h3>Commentaire</h3>
										</div>
										<div class="panel-body">
											<p>{{ memo.commentaire }}</p>
										</div>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</ng-template>
	</ng-template>
</multi-extended-filterable-select2>
